import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

const CancerShape = ({
  width = 40,
  height = 40,
  fillColor = '#FFF',
  style
}: BaseSVGType) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <g id="Layer_2" data-name="Layer 2">
      <g id="Horoscope" fill={fillColor}>
        <g>
          <path d="M11.9,30H12a9.9,9.9,0,0,0,4.6-18.7l-1.5-.6c9.5-4.8,19.5-3.2,27.5,4.8a2,2,0,1,0,2.8-2.8C34,1.1,18.2,1.1,5.3,12.6a9.9,9.9,0,0,0-2.6,11A9.6,9.6,0,0,0,11.9,30ZM12,14a6,6,0,1,1-6,6A6,6,0,0,1,12,14Z" />
          <path d="M36.1,18H36a9.9,9.9,0,0,0-4.6,18.7,9.4,9.4,0,0,0,1.5.6c-9.5,4.8-19.5,3.2-27.5-4.8a1.9,1.9,0,0,0-2.8,0,1.9,1.9,0,0,0,0,2.8c11.4,11.6,27.2,11.6,40.1.1a9.9,9.9,0,0,0,2.6-11A9.6,9.6,0,0,0,36.1,18ZM36,34a6,6,0,1,1,6-6A6,6,0,0,1,36,34Z" />
        </g>
      </g>
    </g>
  </svg>
);

export default CancerShape;
